import styled from 'styled-components';
import { Text, theme } from '@frameio/vapor';

/**
 * @todo (VAPR-2351): Consolidate Link styling and implementation
 * this is used to simulate the StyledLinks. Eventually, once this body of work
 * is complete, we will need to replace this.
 */

export const StyledButton = styled(Text)`
  border-bottom: 1px solid ${theme.colors.border.interactive.hover};
  color: ${theme.colors.text.tertiary};
  cursor: pointer;
  display: inline;
  font-weight: ${theme.fontWeights.semiBold};
`;
